import { Component, OnInit } from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup, ValidationErrors, Validators } from '@angular/forms';
import { CognitoService } from '../../../core/services/cognito.service';
import { ChangePasswordService } from './change-password.service';
import { MessageService } from 'primeng/api';
import { Router } from '@angular/router';

@Component({
  selector: 'app-change-password',
  templateUrl: './change-password.component.html',
  styleUrls: ['./change-password.component.scss'],
})
export class ChangePasswordComponent implements OnInit {
  passwordForm!: FormGroup;
  accessToken: string = '';
  constructor(
    private fb: FormBuilder,
    private cognitoService: CognitoService,
    private changePasswordService: ChangePasswordService,
    private readonly messageService: MessageService,
    private router: Router
  ) {}

  ngOnInit(): void {
    this.cognitoService.getAccessToken().then((data) => {
      this.accessToken = data;
    });
    this.passwordForm = this.fb.group(
      {
        currentPassword: ['', Validators.required],
        newPassword: ['', [Validators.required, Validators.minLength(8)]],
        confirmPassword: ['', Validators.required],
      },
      { validators: this.passwordMatcher }
    );
  }

  preventSpace(event: KeyboardEvent): void {
    if(event.key === ' ') {
      event.preventDefault();
    }
  }

  passwordMatcher(formGroup: FormGroup): { [key: string]: boolean } | null {
    const newPassword = formGroup.get('newPassword')?.value;
    const confirmPassword = formGroup.get('confirmPassword')?.value;
    return newPassword && confirmPassword && newPassword === confirmPassword ? null : { passwordMismatch: true };
  }

  changePassword() {
    const oldPassword = this.passwordForm.get('currentPassword')?.value;
    const newPassword = this.passwordForm.get('newPassword')?.value;

    this.cognitoService
      .changePassword(oldPassword, newPassword)
      .then((message) => {
        this.messageService.add({
          severity: 'success',
          summary: 'Password Updated',
          detail: 'Your password has been successfully updated.',
        });
        this.passwordForm.reset();
        this.cognitoService.signOut();
        setTimeout(()=>{
          this.router.navigate(['/auth/login']);
        },1000)
      })
      .catch((error: any) => {
       let errorMessage: string;

       if (typeof error === 'string') {
          errorMessage = error;
        } else {
          errorMessage = error?.error?.title || error?.error?.message || 'An unexpected error occurred.';
        }
        if (errorMessage === 'Incorrect username or password.') {
            errorMessage = 'Current password is wrong.';
        }
        this.messageService.add({
          severity: 'error',
          summary: 'Error',
          detail: errorMessage,
        });
      });
  }
}
